import { createSlice } from "@reduxjs/toolkit";
import formatDateToISOString from "utils/formatDateToISOString";

export interface ArriveTimeState {
  value: string;
  title: string;
  dateTime: string;
  reservation: boolean;
}

const initialState: ArriveTimeState = {
  value: "now",
  title: "На зараз",
  dateTime: formatDateToISOString(new Date()),
  reservation: false,
};

export const arriveTimeSlice = createSlice({
  name: "arriveTime",
  initialState,
  reducers: {
    setArriveTime: (state, { payload }) => {
      state.value = payload.value;
      state.title = payload.title;
      state.dateTime = payload.dateTime;
      state.reservation = payload.reservation;
    },
    removeArriveTime: () => {
      return initialState;
    },
  },
});

export const { setArriveTime, removeArriveTime } = arriveTimeSlice.actions;
export default arriveTimeSlice.reducer;
